import countriesData from "./CountryInfo.json";

export const getPhoneCodeFromCountryStringCode = (countryStringCode: string) =>
  countriesData?.find((country) => country.code === countryStringCode)?.phoneCode;
